import { useState } from "react";
import { useCourse } from "../firebaseWrapper/firebaseWrapper";
import { useIsMobile } from "../MediaQueries";
import { navigationProps } from "../typings/types";
import { Colors, View, Text, Image } from "react-native-ui-lib";
import { Dimensions, ListRenderItemInfo } from "react-native";
import { ButtonPrimary, ButtonSecondary, LigthweightButton } from "./Buttons";
import { FlatList } from "react-native-gesture-handler";
import { ListItemSimple } from "./general/ListItems";
import { CheckUnitResponseDialog } from "./Dialogs";
import Ionicons from '@expo/vector-icons/Ionicons';
import { evaluateCourse, evaluateOption as evaluateSelectedOption, removeEvaluation as removeUnitEvaluation } from "../courseLogic";

export function CourseScreen({ navigation, route }: navigationProps): JSX.Element {
  const id = route.params.id;
  const isMobile = useIsMobile();
  const [course, courseLoading] = useCourse(id)

  return (
    <View
      flex
      style={{
        backgroundColor: Colors.primaryBG
      }}
    >
      <View flex
        style={{
          backgroundColor: isMobile ? 'transparent' : Colors.secondaryBG,
          borderRadius: isMobile ? 0 : 20,
          marginHorizontal: isMobile ? 0 : 5,
          marginVertical: 5,
          overflow: 'hidden',
        }}
      >
        {course ?
          <View flex style={{ marginHorizontal: isMobile ? 0 : 10, marginVertical: 5, marginBottom: 0 }}>
            <View flex style={{ backgroundColor: 'transparent', borderRadius: 20, paddingVertical: isMobile ? 0 : 20 }}>
              <View style={{ paddingHorizontal: isMobile ? 15 : 25 }}>
                <CourseView course={course} handleFinishCourse={navigation.goBack} />
              </View>
            </View>
          </View>
          : null
        }
      </View>
    </View>
  )
}

export function CourseView({ course, handleFinishCourse }: { course: any, handleFinishCourse?: Function }): JSX.Element {
  const [currentUnit, setCurrentUnit] = useState(course?.units[0])
  const [selectedOption, setSelectedOption] = useState(undefined)
  const [showEvaluationDialog, setShowEvaluationDialog] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const [showCompletionView, setShowCompletionView] = useState(false);
  const [evaluation, setEvaluation] = useState([])
  const isMobile = useIsMobile();
  const coursePassThreshold = 60;
  const dialogMaxHeight = dimensions.height - 120;
  let imgSize = dialogMaxHeight / 2;

  const goToNextUnit = () => {
    setSelectedOption(undefined);
    setShowEvaluationDialog(false);
    if (course.units.length !== course.units.findIndex(unit => unit.id === currentUnit.id) + 1) {
      setCurrentUnit(course.units[course.units.findIndex(unit => unit.id === currentUnit.id) + 1]);
    } else {
      setShowCompletionView(true);
    }
  }

  const goToPreviousUnit = () => {
    const currentUnitIsFirstUnit = course.units.findIndex(unit => unit.id === currentUnit.id) === 0;
    const courseCompleted = showCompletionView === true;
    if (!currentUnitIsFirstUnit && !courseCompleted) {
      const previousUnit = course.units[course.units.findIndex(unit => unit.id === currentUnit.id) - 1];
      setCurrentUnit(previousUnit);
      if (previousUnit.type === "exercise") {
        setEvaluation(current => removeUnitEvaluation(current, previousUnit.id));
      }
    } else if (courseCompleted) {
      const previousUnit = course.units.at(-1);
      if (previousUnit.type === "exercise") {
        setEvaluation(current => removeUnitEvaluation(current, previousUnit.id));
      }
    }
    setSelectedOption(undefined);
    setShowCompletionView(false);
  }

  const handleContinue = () => {
    if (currentUnit.type === "exercise" && selectedOption !== undefined) {
      setShowEvaluationDialog(true)
      setEvaluation(current => evaluateSelectedOption(current, currentUnit, selectedOption));
    } else if (currentUnit.type === "exercise" && selectedOption === undefined) {
      setShowEvaluationDialog(true)
    } else {
      goToNextUnit();
    }
  }

  const coursePercentage = evaluateCourse(course, evaluation);
  const coursePassed = coursePercentage >= coursePassThreshold;

  return (
    <>
      <Text h1 marginB-8 style={{ color: Colors.textPrimary }}>
        {course.title}
      </Text>
      <ProgressBar progress={showCompletionView ? 100 : (course.units.findIndex(unit => unit.id === currentUnit.id)) / course.units.length * 100} />
      {showCompletionView ?
        <>
          <Text h1 color={Colors.textPrimary} marginB-4>
            {coursePassed ? "Glückwunsch!" : "Fast geschafft!"}
          </Text>
          <Text h4 color={Colors.textSecondary} marginB-8>
            {coursePassed ? "Du hast den Kurs abgeschlossen!" : "Schaue dir den Kurs nochmal an um ihn abzuschließen."}
          </Text>
          {course.units.findIndex(unit => unit.id === currentUnit.id) !== 0 ?
            <View row>
              <LigthweightButton
                onPress={goToPreviousUnit}
                label="Back"
                icon={<Ionicons name="arrow-back-outline" size={20} color={Colors.iconSecondary} />}
                iconAllignedRight={false}
              />
            </View> :
            null
          }
          <View center marginB-20>
            <Ionicons name="checkmark-circle-outline" size={200} color={coursePassed ? Colors.greenBG : Colors.redBG} />
            <Text h1 color={coursePassed ? Colors.greenBG : Colors.redBG}>{`${coursePercentage}%`}</Text>
          </View>
          {/* <Text h4>
            Next Courses: ...
          </Text> */}
          <ButtonPrimary
            testID="course-finish-button"
            onPress={handleFinishCourse ? handleFinishCourse : () => { }}
            label={"Alle Kurse"}
          />
        </>
        :
        <View>
          {/* <Text>
          {`Unit ${course.units.findIndex(unit => unit.id === currentUnit.id) + 1}`}
        </Text> */}
          <Text h2 marginT-7 marginB-4 color={Colors.textPrimary}>
            {currentUnit.title || currentUnit.header}
          </Text>
          {course.units.findIndex(unit => unit.id === currentUnit.id) !== 0 ?
            <View row>
              <LigthweightButton
                testID="course-back-button"
                onPress={goToPreviousUnit}
                label="Back"
                icon={<Ionicons name="arrow-back-outline" size={20} color={Colors.iconSecondary} />}
                iconAllignedRight={false}
              />
            </View> :
            null
          }
          <Text content marginV-5 color={Colors.textPrimary}>
            {currentUnit.text}
          </Text>
          <Text content marginV-5 color={Colors.textPrimary}>
            {currentUnit.description}
          </Text>
          <Text content marginV-5 color={Colors.textPrimary}>
            {currentUnit.setting}
          </Text>
          <Text content marginV-5 color={Colors.textPrimary}>
            {currentUnit.question}
          </Text>
          {currentUnit.imageLink ?
            <Image
              marginV-5
              cover
              width={300}
              height={200}
              source={{
                uri: currentUnit.imageLink,
              }}
            />
            :
            null
          }
          {currentUnit.type === "exercise" ?
            <FlatList
              data={currentUnit.options}
              renderItem={({ item, index }) => <ListItemSimple
                testID={`course-option-${index}`}
                label={item}
                onPress={() => setSelectedOption(item)}
                selected={item === selectedOption}
                correct={selectedOption === item && showEvaluationDialog ? selectedOption === currentUnit.solution : undefined}
              />}
              ListHeaderComponent={() => <View margin-5>
                <Text h6 color={Colors.textSecondary}>
                  Wähle eine Antwort aus:
                </Text>
              </View>}
              ItemSeparatorComponent={() => <View margin-2 />}
              ListFooterComponent={() => <View margin-5 />}
              marginV-5
            />
            :
            null
          }
          <Text content marginV-5 color={Colors.textSecondary}>
            {`Source: ${currentUnit.sourceLink}`}
          </Text>
          <ButtonPrimary
            testID="course-continue-button"
            onPress={handleContinue}
            label={selectedOption === undefined ? "Weiter" : "Überprüfen"}
            marginV-5
            muted={currentUnit.type === "exercise" && selectedOption === undefined && showCompletionView === false}
          />
        </View>
      }
      <CheckUnitResponseDialog
        unit={currentUnit}
        selectedOption={selectedOption}
        isVisible={showEvaluationDialog}
        handleContinue={goToNextUnit} />
    </>
  )
}

export function ProgressBar({ progress }: { progress: any }): JSX.Element {
  return (
    <>
      <View style={{ backgroundColor: Colors.tertiaryBG, borderRadius: 10, width: "100%" }} backgroundColor={Colors.tertiaryBG} marginV-10 padding-5 />
      <View style={{ backgroundColor: Colors.backgroundAccent, borderRadius: 20, width: `${progress}%`, marginTop: -20 }} backgroundColor={Colors.backgroundAccent} marginV-10 padding-5 />
    </>
  )
}